import React from 'react';
import styled from 'styled-components';
import { Typography } from '@packages/ui/primitives';
import { COLORS } from '@packages/ui/tokens';
import type { FormProseNode } from '../types/layout';

const variantStyles: Record<NonNullable<FormProseNode['variant']>, string> = {
  info: COLORS.Iris,
  warning: COLORS.Yellow,
  muted: COLORS.Gray,
};

const ProseBlock = styled.div<{ $variant?: FormProseNode['variant'] }>`
  padding: 12px 16px;
  border-radius: 8px;
  background: ${({ $variant }) =>
    $variant === 'warning'
      ? 'rgba(255, 152, 0, 0.08)'
      : $variant === 'info'
        ? 'rgba(33, 150, 243, 0.08)'
        : 'transparent'};
`;

interface FormProseRendererProps {
  node: FormProseNode;
}

export const FormProseRenderer = React.memo(function FormProseRenderer({
  node,
}: FormProseRendererProps): React.ReactElement {
  const color = node.variant ? variantStyles[node.variant] : undefined;

  return (
    <ProseBlock data-form-prose={node.variant ?? 'default'} $variant={node.variant}>
      <Typography variant='body-s' color={color}>
        {node.content}
      </Typography>
    </ProseBlock>
  );
});
